import { Heading, Highlight } from '@chakra-ui/react';
import { StaticImageData } from 'next/image';
import { FC, ReactNode } from 'react';
import { HeadingAs } from '@/shared/types';
import { DefaultContainer } from '@/shared/ui';
import { AboutComponent } from '../AboutComponent';
import type { ContainerProps } from '@chakra-ui/react';

export interface IBenefit {
  heading: string;
  description: string;
  image: StaticImageData;
  button?: ReactNode;
}

interface IBenefitsBlockProps extends ContainerProps {
  heading: string;
  benefits: IBenefit[];
  highlight: string[];
  containerProps?: ContainerProps;
  headingAs?: HeadingAs;
  subHeadingAs?: HeadingAs;
}

const BenefitsBlock: FC<IBenefitsBlockProps> = ({
  heading,
  benefits,
  highlight,
  containerProps,
  headingAs = 'h2',
  subHeadingAs,
  ...props
}) => (
  <>
    <DefaultContainer
      alignItems={{ base: 'start', md: 'center' }}
      containerProps={containerProps}
      gap={{ base: 20, md: 32 }}
      {...props}
    >
      <Heading
        as={headingAs}
        fontWeight='semibold'
        size={{ base: 'xl', md: '2xl' }}
        textAlign={{ base: 'left', md: 'center' }}
      >
        <Highlight
          query={highlight}
          styles={{ color: 'primary.pure' }}
        >
          {heading}
        </Highlight>
      </Heading>
    </DefaultContainer>
    {benefits.map((benefit, index) => {
      const isOdd = index % 2 !== 0;

      return (
        <AboutComponent
          key={benefit.heading}
          headingAs={subHeadingAs}
          imageAlt={benefit.heading}
          imageProps={{ isEager: index === 0 ? true : false }}
          isOdd={isOdd}
          {...benefit}
        />
      );
    })}
  </>
);

export default BenefitsBlock;
